import { Api } from '@parkingboss/api';
import App from './components/App.svelte';

const api = Api({ client: 'media-validator' });

if (!api.isLoggedIn()) {
  api.logIn(true);
} else {
  const app = window.app = new App({
    target: document.body,
    props: { api },
  });
}
